<template>
     <v-expansion-panel focusable  popout  @click.once="getAuthorPublications" >
        <v-expansion-panel-header  :class="{xsclass:xsOnly, lgclass:!xsOnly}" >
            {{ $t("production.lectures") }}
        </v-expansion-panel-header>
        <v-expansion-panel-content class="mx-0"  @click.once="getPersonLectures">
            <app-select-year :key="componentKey" :typeProduction="typeProduction"  :id="id"></app-select-year>
            <app-lectures-list></app-lectures-list>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>
<script>
import lecturesList from '../../research/publications/LecturesList.vue';

import selectYear from '../../research/SelectYear.vue';
import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';

export default {
    props:['id'],
    data(){
        return{
            typeProduction:'lectures',
            showType:true,
            criterias:{
                selectedYear: 1,
                selectedDepartment: 0,
                selectedMember: this.id,
                selectedGrant: 0,
                selectedInvestigator: 0,
                selectedType: 8,
                idDepartmentGrants:0,
            },
            componentKey:0,
        }
    },
    components:{
        'appSelectYear':selectYear,
        'appLecturesList': lecturesList,
    },
    computed:{
        ...mapGetters('header',{
            xsOnly:'xsOnly'
        }),
        ...mapGetters('publication', {
            lecturesOnly:'lecturesOnly'
        }),
    },
    methods: {
        getAuthorPublications(){
            this.setPublications(this.criterias);
        },
        ...mapActions('publication',{
            setPublications:'setPublications',
        }),
        gePersonLectures(){
            this.setPublications(this.criterias);
        }
    },
}
</script>
<style scoped>

.xsclass{
    width: 100%;
}
.lgclass{
    width: 8%;
}
</style>
